import React from 'react'
import { Document } from '../landingpage/components/document';
import { Footer } from '../landingpage/components/footer';
import { ApiEndPoint } from './apiendpoint';
import { ApiOverview } from './apioverview';
import { ApiNavigator } from './apinavigator';
import { StreamingGuide } from './streamingguide';
import { EndPointDoc } from './apireftypes';
import { ApiRef } from '../fasades/apiref';
import { Util } from '../fasades/util';
import './apireference.css';

interface Props {
    doc?: EndPointDoc;
    streaming?: boolean;
}

export class ApiReference extends React.Component<Props> {
    render() {
        const {doc, streaming } = this.props;
        return (
            <>

            <title>API Reference</title>
            <meta
                    name="description"
                    content="Meet Erlend Grønnevet, founder of TigerCity.ai. With a Master's in AI from NTNU and 40+ years of experience, discover the passion driving Norway's next AI success."
            />
            <link rel="canonical" href={Util.getTigerCityUrl() + "apiref"}/>

            <div className="ref-main">
              <div className="ref-vert">
                <ApiNavigator currentDocUrl={doc?.docurl} />
                <div className="api-content">
                  <div className="apiref">
                  <div className="document-view" style={{ flex: '1', minWidth: 0 }}>
                    {streaming ? (
                      <Document classes="main apidocs">
                        <StreamingGuide />
                      </Document>
                    ) : doc ? (
                      <ApiEndPoint doc={doc} />
                    ) : (
                      <Document classes="main apidocs">
                        <ApiOverview endpoints={ApiRef.getAllEndpoints()} />
                      </Document>
                    )}
                  </div>
                  </div>
                </div>
              </div>
              <div className="footer">
                <Footer/>
              </div>
            </div>
            </>
        )
    }
}

